import { getPillarIndicator } from '../helpers';
import { IIndicatorStatus } from '../interfaces';

export const getProtectionIndicator = (emergencyFundRatioIndicator: IIndicatorStatus) =>
  getPillarIndicator(emergencyFundRatioIndicator);
